// extracted by mini-css-extract-plugin
module.exports = {"handle":"handle-248aacbd786c46d9e0c1003d8fbb45be"};